import React from "react";
import { connect } from 'react-redux';
import lodashGet from 'lodash/get';

import StringTranslate from '../../assets/i18n/stringLanguage.jsx';

/* MUI Composants */
import {
    Typography, Box,
    Avatar, List, ListItem, ListItemAvatar, ListItemText,
    Grid, ListItemButton
} from "@mui/material";

/* Sous composants personnalisés. Le style est originaire de Berry */
import MainCard from "../subLayouts/mainCard";
import ConstantsContact from '../../utils/constantsContact.js';

/* MUI Icons */
import AgricultureIcon from '@mui/icons-material/Agriculture';

/* Style MUI, Berry */
import { styled } from '@mui/material/styles';
import getTheme from "../../themes";
import '../../assets/css/profil.css';


let theme = getTheme();

const CardWrapper = styled(MainCard)(({ theme }) => ({
    overflow: 'hidden',
    position: 'relative',
    '&:after': {
        content: '""',
        position: 'absolute',
        width: 210,
        height: 210,
        background: `linear-gradient(210.04deg, ${theme.palette.secondary.dark} -50.94%, rgba(144, 202, 249, 0) 83.49%)`,
        borderRadius: '50%',
        top: -30,
        right: -180
    },
    '&:before': {
        content: '""',
        position: 'absolute',
        width: 210,
        height: 210,
        background: `linear-gradient(140.9deg, ${theme.palette.secondary.dark} -14.02%, rgba(144, 202, 249, 0) 70.50%)`,
        borderRadius: '50%',
        top: -160,
        right: -130
    }
}));

class AboutUs extends React.Component {
    constructor(props) {
        super(props);

        this.state = { 
            //RAS pour le moment
        };
    }

    dependenciesCard = () => {

        return (
            <Grid container>
                <Grid item xs={12} sm={12} md={6}>
                    <List component="nav">

                        <ListItemButton component="a"
                            target="_blank"
                            rel="noopener noreferrer"
                            href="https://emotion.sh/docs/introduction">
                            <ListItemText
                                primary="Emotion Library">
                            </ListItemText>
                        </ListItemButton>

                        <ListItemButton component="a"
                            target="_blank"
                            rel="noopener noreferrer"
                            href="https://mui.com/">
                            <ListItemText primary="Mui Library">
                            </ListItemText>
                        </ListItemButton>

                        <ListItemButton component="a"
                            target="_blank"
                            rel="noopener noreferrer"
                            href="https://stripe.com/" >
                            <ListItemText primary="Stripe: Payment infrastructure" />
                        </ListItemButton>

                        <ListItemButton component="a"
                            target="_blank"
                            rel="noopener noreferrer"
                            href="https://turfjs.org/">
                            <ListItemText primary="Turf: Advanced geospatial analysis for browsers and Node.js">
                            </ListItemText>
                        </ListItemButton>

                        <ListItemButton component="a"
                            target="_blank"
                            rel="noopener noreferrer"
                            href="https://www.npmjs.com/package/base64-js">
                            <ListItemText primary="base64-js: basic base64 encoding/decoding in pure JS">
                            </ListItemText>
                        </ListItemButton>

                        <ListItemButton component="a"
                            target="_blank"
                            rel="noopener noreferrer"
                            href="https://www.npmjs.com/package/color/v/3.1.3">
                            <ListItemText primary="color: library for immutable color conversion and manipulation with support for CSS color strings">
                            </ListItemText>
                        </ListItemButton>

                        <ListItemButton component="a"
                            target="_blank"
                            rel="noopener noreferrer"
                            href="https://www.npmjs.com/package/compressorjs">
                            <ListItemText primary="Compressorjs: JavaScript image compressor">
                            </ListItemText>
                        </ListItemButton>

                        <ListItemButton component="a"
                            target="_blank"
                            rel="noopener noreferrer"
                            href="https://www.npmjs.com/package/d3/v/6.2.0">
                            <ListItemText primary="D3: Data-Driven Documents">
                            </ListItemText>
                        </ListItemButton>

                        <ListItemButton component="a" target="_blank"
                            rel="noopener noreferrer"
                            href="https://date-fns.org/">
                            <ListItemText primary="date-fns: date utility library">
                            </ListItemText>
                        </ListItemButton>

                        <ListItemButton component="a"
                            target="_blank"
                            rel="noopener noreferrer"
                            href="https://day.js.org/">
                            <ListItemText primary="day.js: library that parses, validates, manipulates, and displays dates and times">
                            </ListItemText>
                        </ListItemButton>

                        <ListItemButton component="a"
                            target="_blank"
                            rel="noopener noreferrer"
                            href="https://www.npmjs.com/package/js-sha1">
                            <ListItemText primary="js-sha1: A simple SHA1 hash function for JavaScript supports UTF-8 encoding">
                            </ListItemText>
                        </ListItemButton>

                        <ListItemButton component="a"
                            target="_blank"
                            rel="noopener noreferrer"
                            href="https://stuk.github.io/jszip/">
                            <ListItemText primary="JSZip: library for creating, reading and editing .zip files">
                            </ListItemText>
                        </ListItemButton>

                        <ListItemButton component="a"
                            target="_blank"
                            rel="noopener noreferrer"
                            href="https://leafletjs.com/">
                            <ListItemText primary="Leaflet: library for mobile-friendly interactive maps.">
                            </ListItemText>
                        </ListItemButton>

                        <ListItemButton component="a"
                            target="_blank"
                            rel="noopener noreferrer"
                            href="https://www.esri.com/">
                            <ListItemText primary="ESRI: A spatial system that creates, manages, analyzes, and maps all types of data.">
                            </ListItemText>
                        </ListItemButton>

                        <ListItemButton component="a"
                            target="_blank"
                            rel="noopener noreferrer"
                            href="https://lodash.com/">
                            <ListItemText primary="lodash: library delivering modularity, performance & extras">
                            </ListItemText>
                        </ListItemButton>

                        <ListItemButton component="a"
                            target="_blank"
                            rel="noopener noreferrer"
                            href="https://www.npmjs.com/package/luxon">
                            <ListItemText primary="Luxon: library for working with dates and times in JavaScript">
                            </ListItemText>
                        </ListItemButton>

                        <ListItemButton component="a"
                            target="_blank"
                            rel="noopener noreferrer"
                            href="https://www.npmjs.com/package/moment/v/2.24.0">
                            <ListItemText primary="moment: date library for parsing, validating, manipulating, and formatting dates">
                            </ListItemText>
                        </ListItemButton>

                        <ListItemButton component="a"
                            target="_blank"
                            rel="noopener noreferrer"
                            href="https://docs.microsoft.com/en-us/azure/active-directory/develop/msal-overview">
                            <ListItemText primary="MSAL: Microsoft Authentication Library (MSAL) enables developers to acquire tokens from the Microsoft identity platform in order to authenticate users and access secured web APIs">
                            </ListItemText>
                        </ListItemButton>

                        <ListItemButton component="a"
                            target="_blank"
                            rel="noopener noreferrer"
                            href="https://reactjs.org/">
                            <ListItemText primary="React: JavaScript library for building user interfaces">
                            </ListItemText>
                        </ListItemButton>

                        <ListItemButton component="a"
                            target="_blank"
                            rel="noopener noreferrer"
                            href="https://recharts.org/en-US/">
                            <ListItemText primary="Recharts: date utility library">
                            </ListItemText>
                        </ListItemButton>

                        <ListItemButton component="a"
                            target="_blank"
                            rel="noopener noreferrer"
                            href="https://redux.js.org/">
                            <ListItemText primary="Redux: A Predictable State Container for JS Apps">
                            </ListItemText>
                        </ListItemButton>
                        
                        <ListItemButton component="a"
                            target="_blank"
                            rel="noopener noreferrer"
                            href="https://help.productfruits.com/en">
                            <ListItemText primary="Productfruit: Track users' actions">
                            </ListItemText>
                        </ListItemButton>

                        <ListItemButton component="a"
                            target="_blank"
                            rel="noopener noreferrer"
                            href="https://onesignal.com/">
                            <ListItemText primary="Onesignal: Push notifications, email, SMS, Live Activities, and in-app messaging to develop engaged and loyal customers">
                            </ListItemText>
                        </ListItemButton>

                    </List>
                </Grid>

                <Grid item xs={12} sm={12} md={6}>
                    <List component="nav">

                        <ListItemButton component="a"
                            target="_blank"
                            rel="noopener noreferrer"
                            href="https://www.npmjs.com/package/shpjs">
                            <ListItemText primary="Shapefile.js: A binary shapefile loader, for javascript">
                            </ListItemText>
                        </ListItemButton>

                        <ListItemButton component="a"
                            target="_blank"
                            rel="noopener noreferrer"
                            href="https://spin.js.org/">
                            <ListItemText primary="Spin.js dynamically creates spinning activity indicators that can be used as a resolution-independent replacement for loading GIFs">
                            </ListItemText>
                        </ListItemButton>

                        <ListItemButton component="a"
                            target="_blank"
                            rel="noopener noreferrer"
                            href="https://styled-components.com/">
                            <ListItemText primary="styled-components: Visual primitives for the component age.">
                            </ListItemText>
                        </ListItemButton>

                        <ListItemButton component="a"
                            target="_blank"
                            rel="noopener noreferrer"
                            href="https://www.typescriptlang.org/">
                            <ListItemText primary="TypeScript: typed programming language that builds on JavaScript, giving you better tooling at any scale">
                            </ListItemText>
                        </ListItemButton>

                        <ListItemButton component="a"
                            target="_blank"
                            rel="noopener noreferrer"
                            href="https://www.geoapi.org/">
                            <ListItemText primary="GeoAPI: provides a set programming interfaces for geospatial applications">
                            </ListItemText>
                        </ListItemButton>

                        <ListItemButton component="a"
                            target="_blank"
                            rel="noopener noreferrer"
                            href="https://www.antlr.org/">
                            <ListItemText primary="Antlr: (ANother Tool for Language Recognition) is a powerful parser generator for reading, processing, executing, or translating structured text or binary files.">
                            </ListItemText>
                        </ListItemButton>

                        <ListItemButton component="a"
                            target="_blank"
                            rel="noopener noreferrer"
                            href="https://getbootstrap.com/">
                            <ListItemText primary="Bootstrap: Quickly design and customize responsive mobile-first sites">
                            </ListItemText>
                        </ListItemButton>

                        <ListItemButton component="a"
                            target="_blank"
                            rel="noopener noreferrer"
                            href="https://www.nuget.org/packages/Ical.Net">
                            <ListItemText primary="Ical.net: an open source iCal library for .NET">
                            </ListItemText>
                        </ListItemButton>

                        <ListItemButton component="a"
                            target="_blank"
                            rel="noopener noreferrer"
                            href="https://jquery.com/">
                            <ListItemText primary="jQuery: JavaScript library, It makes things like HTML document traversal and manipulation, event handling, animation, and Ajax much simpler with an easy-to-use API that works across a multitude of browsers">
                            </ListItemText>
                        </ListItemButton>

                        <ListItemButton component="a"
                            target="_blank"
                            rel="noopener noreferrer"
                            href="https://docs.microsoft.com/en-us/azure/azure-monitor/app/app-insights-overview">
                            <ListItemText primary="Microsoft.ApplicationInsights: This package is a feature of Azure Monitor that provides extensible application performance management (APM) and monitoring for live web apps">
                            </ListItemText>
                        </ListItemButton>

                        <ListItemButton component="a"
                            target="_blank"
                            rel="noopener noreferrer"
                            href="https://dotnet.microsoft.com/en-us/apps/aspnet">
                            <ListItemText primary="ASP.net: ASP.NET is an open source web framework, created by Microsoft, for building modern web apps and services with .NET">
                            </ListItemText>
                        </ListItemButton>

                        <ListItemButton component="a"
                            target="_blank"
                            rel="noopener noreferrer"
                            href="https://docs.microsoft.com/en-us/microsoft-365/security/office-365-security/bulk-complaint-level-values?view=o365-worldwide">
                            <ListItemText primary="Bulk complaint level">
                            </ListItemText>
                        </ListItemButton>

                        <ListItemButton component="a"
                            target="_blank"
                            rel="noopener noreferrer"
                            href="https://docs.microsoft.com/en-us/dotnet/framework/reflection-and-codedom/using-the-codedom">
                            <ListItemText primary="CodeDOM: The .NET Framework includes a mechanism called the Code Document Object Model (CodeDOM) that enables developers of programs that emit source code to generate source code in multiple programming languages at run time, based on a single model that represents the code to render">
                            </ListItemText>
                        </ListItemButton>

                        <ListItemButton component="a"
                            target="_blank"
                            rel="noopener noreferrer"
                            href="https://docs.microsoft.com/en-us/azure/active-directory/develop/">
                            <ListItemText primary="Microsoft identity platform: Evolution of the Azure Active Directory (Azure AD) developer platform. It allows developers to build applications that sign in users, and access resources in both external applications such as SaaS applications as well as internal resources, such as apps on your corporate network and intranet, along with any cloud apps developed by your own organization">
                            </ListItemText>
                        </ListItemButton>

                        <ListItemButton component="a"
                            target="_blank"
                            rel="noopener noreferrer"
                            href="https://docs.microsoft.com/en-us/aspnet/core/fundamentals/owin?view=aspnetcore-6.0">
                            <ListItemText primary="Open Web Interface: OWIN allows web apps to be decoupled from web servers.">
                            </ListItemText>
                        </ListItemButton>

                        <ListItemButton component="a"
                            target="_blank"
                            rel="noopener noreferrer"
                            href="https://modernizr.com/">
                            <ListItemText primary="Modernizr: Modernizr tells you what HTML, CSS and JavaScript features the user’s browser has to offer">
                            </ListItemText>
                        </ListItemButton>

                        <ListItemButton component="a"
                            target="_blank"
                            rel="noopener noreferrer"
                            href="https://nettopologysuite.github.io/">
                            <ListItemText primary="NetTopologySuite: A .NET GIS solution that is fast and reliable for the .NET platform.">
                            </ListItemText>
                        </ListItemButton>

                        <ListItemButton component="a"
                            target="_blank"
                            rel="noopener noreferrer"
                            href="https://www.newtonsoft.com/json">
                            <ListItemText primary="Newtonsoft.Json: Popular high-performance JSON framework for .NET">
                            </ListItemText>
                        </ListItemButton>

                        <ListItemButton component="a"
                            target="_blank"
                            rel="noopener noreferrer"
                            href="https://www.nuget.org/packages/WebGrease/">
                            <ListItemText primary="WebGrease: Web Grease is a suite of tools for optimizing javascript, css files and images.">
                            </ListItemText>
                        </ListItemButton>

                        <ListItemButton component="a"
                            target="_blank"
                            rel="noopener noreferrer"
                            href="https://plantnet.org/en/">
                            <ListItemText primary="PlantNet: With the Pl@ntNet app, identify one plant from a picture, and be part of a citizen science project on plant biodiversity">
                            </ListItemText>
                        </ListItemButton>

                    </List>
                </Grid>
            </Grid>
        );
    }

    render() {
        return (
            <Box
                sx={{
                    height: "fit-content"
                }}
            >
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <CardWrapper border={false} content={false}>
                            <Box sx={{ p: 2 }}>
                                <List sx={{ py: 0 }}>
                                    <ListItem alignItems="center" disableGutters
                                        sx={{
                                            py: 0,
                                            "&:hover": {
                                                backgroundColor: "transparent"
                                            }
                                        }}>
                                        <ListItemAvatar>
                                            <Avatar
                                                variant="rounded"
                                                component="a"
                                                sx={{
                                                    ...theme.typography.commonAvatar,
                                                    ...theme.typography.largeAvatar,
                                                    backgroundColor: theme.palette.secondary.light,
                                                    color: theme.palette.secondary.dark
                                                }}
                                                target="_blank"
                                                href='https://www.spotifarm.fr/'
                                            >
                                                <AgricultureIcon fontSize="inherit" />
                                            </Avatar>
                                        </ListItemAvatar>
                                        <ListItemText
                                            sx={{
                                                py: 0,
                                                mt: 0.45,
                                                mb: 0.45
                                            }}
                                            primary={
                                                <Grid container>
                                                    <Grid item xs={12}>
                                                        <Typography
                                                            component="a"
                                                            variant="h4"
                                                            target="_blank"
                                                            href='https://www.spotifarm.fr/'>
                                                            Spotifarm
                                                        </Typography>
                                                    </Grid>
                                                </Grid>
                                            }
                                            secondary={
                                                <Grid container>
                                                    <Grid item xs={12}>
                                                        <Typography
                                                            variant="subtitle2"
                                                            component="a"
                                                            sx={{
                                                                color: theme.palette.grey[500],
                                                                mt: 0.5, 
                                                                cursor:"pointer"
                                                            }}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            href={ConstantsContact.UrlCGV}
                                                        >
                                                            {StringTranslate.termsAndConditionsSpotifarm}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <Typography
                                                            variant="subtitle2"
                                                            component="a"
                                                            sx={{
                                                                color: theme.palette.grey[500],
                                                                mt: 0.5, 
                                                                cursor:"pointer"
                                                            }}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            href={ConstantsContact.UrlPGD}
                                                        >
                                                            {StringTranslate.pgdlink}
                                                        </Typography>
                                                    </Grid>
                                                </Grid>
                                            }
                                        />
                                    </ListItem>
                                </List>
                            </Box>
                        </CardWrapper>
                    </Grid>

                    <Grid item xs={12}>
                        <MainCard title={StringTranslate.dependenciesApi}>
                            {this.dependenciesCard()}
                        </MainCard>
                    </Grid>

                </Grid>
            </Box>
        );
    }
}

const mapStateToProps = state => ({
    profilPageUrl: lodashGet(state, 'contextAppData.profilPageUrl', undefined),
})

const mapDispatchToProps = dispatch => ({
})

export default connect(mapStateToProps, mapDispatchToProps)(AboutUs);